<template>
  <div class="sp-template">
    <div class="h-title">月报表</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" class="header-search__form" size="small" label-width="90px">
          
          
          <el-row>
            <el-form-item label="交易月">
              <el-date-picker v-model="month" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="交易月"></el-date-picker>
            </el-form-item>
          </el-row>

          <div class="search-form__buttons">
            <el-button  type="primary" size="small" @click="exportData(1)" >导出汇总</el-button>
            <el-button  type="primary" size="small" @click="exportData(2)" >导出成本明细</el-button>
            <el-button  type="primary" size="small" @click="exportData(3)" >导出收入明细</el-button>
            
            
          </div>
        </el-form>
      </div>
      <div class="table-button__groups">
        <!-- <div class="button-groups">
          <el-button  size="small" @click="freezeOrder">导出1</el-button>
        </div> -->
      </div>


    </el-card>

  </div>
</template>

<script>
// import {getFreezeOrder,getUnlock,textPost} from '@/util/reconciliation'
import { pickerOptions, base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      month: ''

    };
  },
  created() {
    let _this =  this;
    setTimeout(() => {
    }, 1000);  

    if (!_this.month) {
      _this.month = this.dateFormat(new Date(), 'yyyy-MM');
    }

  },
  methods: {
    exportData(num){
      let _this = this;
      console.log(this.month);
      if (!_this.month) {
        // _this.$alert('请选择月份');
        _this.$message.error("请选择月份");        
      }

      // let url  = tmsSpringUrl + '/month-report/' + _this.month + '/' + num + ''
      // this.$windowOpen1(url)

      this.$request1({
        url: '/month-report/' + _this.month + '/' + num + '',
        method: 'get',
        
      }).then(res => {
        if(res.data.success){
          const link = document.createElement('a')
          let array = base64ToUint8Array(res.data.data)
          // let blob = new Blob([array], { type: 'application/zip' }) // 设置正确的 MIME 类型
          let blob = new Blob([array])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          var timestr2 = timestr.slice(2, 12)
          link.setAttribute('download', `月报表_${timestr2}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }else {
          _this.$message.error(res.data.message);
        }
      })

      


    },
    dateFormat(date, fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .shouru .el-checkbox__inner {
  border-radius: 50% !important;
}
</style>
<style scoped>
  .chgstyle >>> .el-checkbox__inner {
      border-radius: 50% !important;
  }
</style>





// WEBPACK FOOTER //
// src/views/account/mothreport.vue